<template><div class="d-flex justify-center">

<div style="max-width: 900px">
	<v-card>
		 <v-card-title>
	      {{ $t('Updates') }}
	      <v-spacer></v-spacer>
	      <v-text-field
	        v-model="search"
	        :append-icon="$mdi.Magnify"
	        label="Search"
	        single-line
	        hide-details
	      ></v-text-field>
	    </v-card-title>

	    <p class="pl-3"> The website was last updated on: {{last_update.toLocaleString() }} </p>

		<v-data-table
			:search="search"
			:headers="headers"
			:items="upd"
			:items-per-page="10"
			class="elevation-1"
		>
		    <template v-slot:item.status="{ item }">
		      <v-chip
		        :color="item.status == 'new' ? 'green' : 'orange'"
		        dark
		      >
		        {{ item.status }}
		      </v-chip>
		    </template>

		    <template v-slot:item.url="{ item }">
		    	<div v-if="item.url">
		    		<router-link v-if="item.url[0] == '/'" class="nowrap" :to="item.url"> {{item.url}} </router-link>
		    		<a :href="item.url" v-else> {{item.url}} </a>
		    	</div>
		    </template>
		</v-data-table>
	</v-card>
</div>

</div></template>

<script>


export default {
	components: {},
	data() {
		return {
			search: ''
		}
	},
	computed: {
		upd() {
			return this.$g.updates.filter(u => u.language == 'en' || u.language == this.$store.state.language || u.language === undefined);
		}
	},
	methods: {

	},
	created() {
		this.headers = [
          { text: 'URL', value: 'url' },
          { text: 'Comment', value: 'comment' },
          { text: 'Status', value: 'status' },
          { text: 'Date', value: 'date' },
		];
		this.last_update = new Date( preval`module.exports = (new Date()).valueOf()` );
		//console.log(this.last_update);
	}
}
</script>

<style>

.nowrap {
	white-space:nowrap;
}

</style>